import React from 'react';
import { validators, formats, dates } from 'investira.sdk';
import { Chip, Stack, Tooltip, Typography, CircularProgress } from 'investira.react.components';
import { UPLOAD_TIPO } from '../../enums';

const columns = [
  {
    id: 'data_envio',
    accessorKey: 'data_envio',
    header: 'Envio',
    enableColumnActions: false,
    enableSorting: false,
    filterVariant: 'date-range',
    maxSize: 100,
    Cell: ({ cell }) => {
      if (validators.isNull(cell.getValue())) {
        return 'AUSENTE';
      }

      return formats.formatDate(dates.toDate(cell.getValue()));
    }
  },
  {
    accessorKey: 'arquivo',
    header: 'Arquivo',
    enableColumnActions: false,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => {
      if (validators.isNull(cell.getValue())) {
        return <Typography variant="body2">AUSENTE</Typography>;
      }

      return (
        <Typography variant="body2">{String(cell.getValue()).replace(/\.xml$/i, '')}</Typography>
      );
    }
  },
  {
    id: 'status',
    accessorKey: 'ifeed_upload_fim',
    header: 'Status',
    enableColumnActions: false,
    enableSorting: false,
    enableColumnFilter: false,
    maxSize: 80,
    muiTableHeadCellProps: () => {
      return { align: 'center' };
    },
    muiTableBodyCellProps: () => {
      return { align: 'center' };
    },
    Cell: xProps => {
      const { cell, row } = xProps;

      if (!validators.isEmpty(row.original.ifeed_erros)) {
        const xError = 'Erro';

        return (
          <Tooltip
            arrow
            title={
              <Stack
                spacing={1}
                sx={{
                  px: 2,
                  py: 1,
                  whiteSpace: 'normal'
                }}>
                {validators.isArray(row.original.ifeed_erros) ? (
                  row.original.ifeed_erros.map((error, index) => {
                    return (
                      <Stack key={`file-error-${index}`} spacing={1}>
                        <Typography variant="caption" color="textPrimary">
                          {error.description || error}
                        </Typography>
                      </Stack>
                    );
                  })
                ) : (
                  <Typography variant="caption" color="textPrimary">
                    {row.original.ifeed_erros.description ||
                      JSON.stringify(row.original.ifeed_erros.erros)}
                  </Typography>
                )}
              </Stack>
            }>
            <span>
              <Chip size="small" label={xError} color="error" sx={{ cursor: 'help' }} />
            </span>
          </Tooltip>
        );
      }

      if (!validators.isNull(cell.getValue())) {
        return <Chip size="small" label="Ok" color="success" />;
      }

      if (!validators.isNull(row.original.arquivo)) {
        return <CircularProgress size={24} />;
      }

      return null;
    }
  },
  {
    id: 'origem',
    accessorKey: 'origem',
    header: 'Origem',
    enableColumnActions: false,
    enableSorting: false,
    filterVariant: 'multi-select',
    maxSize: 100,
    Cell: ({ cell }) => {
      if (validators.isNull(cell.getValue())) {
        return 'AUSENTE';
      }

      return UPLOAD_TIPO[cell.getValue()]?.label || cell.getValue();
    }
  },
  {
    id: 'carteira_seuid',
    accessorKey: 'carteira_seuid',
    header: 'Carteira',
    enableColumnActions: false,
    enableSorting: false,
    filterVariant: 'multi-select',
    Cell: ({ cell }) => {
      if (validators.isNull(cell.getValue())) {
        return 'AUSENTE';
      }

      return cell.getValue();
    }
  },
  {
    id: 'ifeed_data_posicao',
    accessorKey: 'ifeed_data_posicao',
    header: 'Posição',
    enableColumnActions: false,
    enableSorting: false,
    filterVariant: 'date-range',
    maxSize: 100,
    Cell: ({ cell }) => {
      if (validators.isNull(cell.getValue())) {
        return 'AUSENTE';
      }

      return formats.formatDate(dates.toDate(cell.getValue()));
    }
  }
];

export default columns;
